interface ProgressBarProps {
  currentStep: number
  totalSteps: number
  imagenUrl?: string | null
  titulo?: string
}

export function ProgressBar({ currentStep, totalSteps, imagenUrl, titulo }: ProgressBarProps) {
  const percentage = totalSteps > 0 ? Math.round((currentStep / totalSteps) * 100) : 0

  return (
    <div className="space-y-3 sm:space-y-4">
      {/* Steps and Campaign Image */}
      <div className="flex flex-col sm:flex-row items-center justify-between px-2 sm:px-4 space-y-3 sm:space-y-0">
        {/* Campaign Image - Mobile first */}
        {imagenUrl && (
          <div className="flex justify-center w-full sm:w-auto sm:order-2">
            <img
              src={imagenUrl}
              alt={titulo || ''}
              className="max-w-28 w-auto h-12 sm:max-w-32 sm:h-16 lg:max-w-40 lg:h-20 object-contain"
              onError={(e) => { e.currentTarget.style.display = 'none' }}
            />
          </div>
        )}

        {/* Step indicators */}
        <div className="flex items-center space-x-2 sm:space-x-3 lg:space-x-6 sm:order-1">
          {Array.from({ length: totalSteps }, (_, i) => i + 1).map((step) => (
            <div key={step} className="flex items-center">
              <div className="flex flex-col items-center">
                <span
                  className={`flex items-center justify-center w-6 h-6 sm:w-8 sm:h-8 rounded-full border-2 text-xs font-semibold mb-1 ${
                    step <= currentStep
                      ? 'border-blue-600 bg-blue-600 text-white'
                      : 'border-gray-300 text-gray-400'
                  }`}
                >
                  {step}
                </span>
                <span className={`text-xs font-medium hidden sm:block ${
                  step <= currentStep ? 'text-blue-600' : 'text-gray-400'
                }`}>
                  Paso {step}
                </span>
              </div>
              {step < totalSteps && (
                <div className="flex items-center ml-2 sm:ml-3 lg:ml-6">
                  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Progress Bar */}
      <div className="bg-blue-100 h-2 rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-blue-600 to-blue-700 transition-all duration-300 rounded-full"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  )
}
